import { defineMessages } from 'react-intl';

export default defineMessages({
    AccountHolderName: {
        id: 'cep.components.sgPolicyPaymentTile.AccountHolderName',
        defaultMessage: 'Account holder name'
    },
    AccountNumber: {
        id: 'cep.components.sgPolicyPaymentTile.AccountNumber',
        defaultMessage: 'Account number'
    },
    SortCode: {
        id: 'cep.components.sgPolicyPaymentTile.SortCode',
        defaultMessage: 'Sort code'
    },
    DirectDebitStatus: {
        id: 'cep.components.sgPolicyPaymentTile.DirectDebitStatus',
        defaultMessage: 'Direct debit instruction status'
    },
});
